import createPayloads from './createPayloads';
import {
    adicionarContatoEmContrato,
    adicionarPerfil,
    alterarContatoDoContrato,
    getContatosPorContrato,
    removerContatoDoContrato,
    removerPerfil,
} from '../../../../services';

function createAdditions(list, dataForm, dataUser) {
    return list.map(async (contract) => {
        const { payloadContato, payloadPerfil } = createPayloads(dataForm, 'add', contract);

        const responseAddProfile = await adicionarPerfil(payloadPerfil);

        if (responseAddProfile === 409) {
            return { status: 409, contract };
        }

        const responseAddContact = await adicionarContatoEmContrato(contract, payloadContato);

        if (![200, 201].includes(responseAddContact.status)) {
            await removerPerfil({ email: dataUser.email.value, contrato: contract });

            return { mode: 'add', contract, status: 500 };
        }

        return { status: responseAddProfile };
    });
}

function createDeletes(list, dataForm, dataUser) {
    return list.map(async (contract) => {
        const [dataContato] = await getContatosPorContrato(contract, dataUser.email.value);

        const responseDeletionTop = await removerContatoDoContrato(contract, dataContato.numeroSequencialContato);

        if (![200, 201].includes(responseDeletionTop.status)) {
            return { mode: 'delete', contract, status: 500 };
        }

        const responseDeletionProfile = await removerPerfil({ email: dataUser.email.value, contrato: contract });

        return { status: responseDeletionProfile.status };
    });
}

function createUpdates(list, dataForm, dataUser) {
    return list.map(async (contract) => {
        const { payloadContato, payloadPerfil } = createPayloads(dataForm, 'add', contract);

        const errorResponse = {
            mode: 'update',
            contract,
            status: 500,
        };

        const [dataContato] = await getContatosPorContrato(contract, dataUser.email.value);

        if (dataContato?.numeroSequencialContato) {
            const responseAlterar = await alterarContatoDoContrato(
                contract,
                dataContato.numeroSequencialContato,
                payloadContato
            );

            if (responseAlterar.length === 0) return errorResponse;

            const responseRemove = await removerPerfil({ email: dataUser.email.value, contrato: contract });

            if (responseRemove === 500) return errorResponse;

            const responseAddition = await adicionarPerfil(payloadPerfil);

            if (responseAddition === 500) return errorResponse;

            return responseAlterar;
        }

        return errorResponse;
    });
}

export { createAdditions, createDeletes, createUpdates };
